import Vue from 'vue'
import VueRouter from 'vue-router'
import OrderDb from '@/components/OrderDb.vue'
import TransorderDb from '@/components/Transorderdb.vue'
import PgDb from '@/components/Pgdb.vue'
import JsonComparison from '@/components/JsonComparison.vue'
import OrderComparison from '@/components/OrderComparison.vue'
import PlanCheck from '@/components/PlanCheck.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Homepage',
    component: () => import('@/components/HomePage.vue')
  },
  {
    path: '/ordercomparison/orderdb',
    name: 'Orderdb',
    component: OrderDb
  },
  {
    path: '/ordercomparison/transorderdb',
    name: 'Transorderdb',
    component: TransorderDb
  },
  {
    path: '/ordercomparison/pgdb',
    name: 'Pgdb',
    component: PgDb
  },
  {
    path: '/jsoncomparison',
    name: 'JsonComparison',
    component: JsonComparison
  },
  {
    path: '/ordercomparison',
    name: 'OrderComparison',
    component: OrderComparison
  },
  {
    path: '/plancheck',
    name: 'PlanCheck',
    component: PlanCheck
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router